import React from "react";
import { Modal, ModalBody } from "reactstrap";

import { ListaOcorrencias, useOcorrencias } from "../Ocorrencias";

// Modal do histórico, usado por Entregas Pendentes. O Rastreamento mostra a
// mesma lista inline no resultado (ver ../Ocorrencias).
const ModalOcorrencia = ({ modal, toggle, notaFiscal }) => {
  const { ocorrencias, error } = useOcorrencias(notaFiscal, modal);

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      size="lg"
      modalClassName="modal-align-top tracking-occurrence-modal"
      contentClassName="tracking-occurrence-modal__content"
      fade={false}
    >
      <div className="tracking-modal-header">
        <div>
          <div className="tracking-eyebrow">Histórico</div>
          <h3>Ocorrências da entrega</h3>
          <p>Rastreio Everlog #{notaFiscal || "-"}</p>
        </div>
        <button
          type="button"
          onClick={toggle}
          className="tracking-modal-close"
          aria-label="Fechar"
        >
          ×
        </button>
      </div>

      <ModalBody className="tracking-modal-body">
        <ListaOcorrencias ocorrencias={ocorrencias} error={error} />
      </ModalBody>
    </Modal>
  );
};

export default ModalOcorrencia;
